import { createFileRoute } from "@tanstack/react-router";
import { SharedItem, sharedItemHead } from "../components/SharedItem";
import { documentHeaders } from "../lib/seo";

/**
 * `/post/<code>` — the web side of a shared post link.
 *
 * On a phone with Bible Shield installed this page is never reached: iOS and
 * Android hand the URL to the app instead (that is what the association files
 * in `/.well-known` buy us). This is the fallback for everyone else, and what it
 * does and does not show is explained in `SharedItem`.
 *
 * The path segment is the post's opaque SHARE CODE, not its id (SHARE-01) — it
 * is there so the app receives it; the page itself doesn't use it, and nothing
 * about the record is fetched or rendered here.
 */
export const Route = createFileRoute("/post/$id")({
  headers: documentHeaders,
  head: () => sharedItemHead("post"),
  component: () => <SharedItem kind="post" />,
});
